import { JSONEditor } from '@json-editor/json-editor'
// import _ from 'lodash'
// import { extend } from '../utilities.js'

class TypeSelector extends JSONEditor.AbstractEditor {
  constructor (options, defaults) {
    super(options, defaults)
    this.previousChildEditorType = null
    this.currentChildEditorType = null
    this.cachedValues = {}

    // removing for now; was causing an issue with editor updates somehow.
    // this.refreshValueDebounced = _.debounce(this.refreshValue, 1)
  }

  register () {
    if (this.typeEditor) this.typeEditor.unregister()
    if (this.childEditor) this.childEditor.unregister()

    if (this.typeEditor) this.typeEditor.register()
    if (this.childEditor) this.childEditor.register()
    super.register()
  }

  unregister () {
    super.unregister()
    if (this.typeEditor) {
      this.typeEditor.unregister()
    }
    if (this.childEditor) {
      this.childEditor.unregister()
    }
  }

  preBuild () {
    super.preBuild()

    this.typePropertyName = this.options.typeProperty || 'type'
    if (!this.schema.properties[this.typePropertyName]) {
      throw new Error(`TypeSelector::Missing ${this.typePropertyName} property in schema`)
    }

    const editorClass = this.jsoneditor.getEditorClass(this.schema.properties[this.typePropertyName])
    const typeEditorSchema = this.schema.properties[this.typePropertyName]
    this.typeEditor = this.jsoneditor.createEditor(editorClass, {
      jsoneditor: this.jsoneditor,
      schema: typeEditorSchema,
      path: `${this.path}.${this.typePropertyName}`,
      parent: this
    })
    this.typeEditor.preBuild()
  }

  build () {
    this.header = document.createElement('span')
    this.header.textContent = this.getTitle()
    this.title = this.theme.getHeader(this.header)
    this.title.classList.add('je-object__title')
    this.container.appendChild(this.title)
    this.container.classList.add('je-object__container')

    this.editor_holder = this.theme.getIndentedPanel()
    this.container.appendChild(this.editor_holder)

    this.row_container = this.theme.getGridContainer()
    this.editor_holder.appendChild(this.row_container)

    const typeEditorHolder = this.theme.getGridColumn()
    this.row_container.appendChild(typeEditorHolder)

    this.jsoneditor.watch(this.typeEditor.path, () => {
      console.log('watch::typeEditor value changed', this.typeEditor.getValue())
      if (this.typeEditor.getValue() !== this.currentChildEditorType) {
        this.previousChildEditorType = this.currentChildEditorType
        this.currentChildEditorType = this.typeEditor.getValue()
        console.log('watch -- calling switchEditor')
        this.switchEditor()
      }
    })
    this.typeEditor.setContainer(typeEditorHolder)
    this.typeEditor.build()
    console.log('type after build : ', this.typeEditor.getValue()) // value is set at this point
    this.typeEditor.postBuild()
  }

  setValue (value, initial) {
    console.log('typeselector set value', value, initial)
    value = value || {}

    // const prevType = this.typeEditor.getValue()
    const typeEditorVal = value[this.typePropertyName] ?? this.typeEditor.getDefault()
    this.typeEditor.setValue(typeEditorVal, initial)

    console.log('setVal:', value, initial)
    console.log('childeditor:', this.childEditor)
    if (this.childEditor) {
      console.log('setting value of childEditor', value[typeEditorVal])
      console.log('typeEditorVal', typeEditorVal)
      this.childEditor.setValue(value[typeEditorVal], initial)
    }
  }

  onChildEditorChange (editor) {
    this.refreshValue()
    // see note above about why we're removing
    // this.refreshValueDebounced()
    super.onChildEditorChange(editor)
  }

  switchEditor () {
    console.log('switch editor')
    if (this.childEditor) {
      this.cacheValue(this.previousChildEditorType)

      console.log('switchEditor::destroying childEditor')
      this.childEditor.destroy()
      this.childEditor = null
    }

    const type = this.typeEditor.getValue()
    this.buildChildEditor(type)

    this.register()

    // if switching back to a previous editor type, restore the cached value
    const childEditorValue = this.cachedValues[type] || this.childEditor.getDefault()
    this.childEditor.setValue(childEditorValue)

    this.refreshValue()
  }

  buildChildEditor (type) {
    const editorClass = this.jsoneditor.getEditorClass(this.schema.properties[type])
    const childSchema = this.schema.properties[type]
    this.childEditor = this.jsoneditor.createEditor(editorClass, {
      jsoneditor: this.jsoneditor,
      schema: childSchema,
      path: `${this.path}.${type}`,
      parent: this
    })
    this.childEditor.preBuild()

    const childEditorHolder = this.theme.getGridColumn()
    this.row_container.appendChild(childEditorHolder)
    this.childEditor.setContainer(childEditorHolder)

    this.childEditor.build()
    this.childEditor.postBuild()
    console.log('childEditor post build')
  }

  cacheValue (key) {
    if (!key) return

    if (this.childEditor && this.childEditor.getValue()) {
      this.cachedValues[key] = this.childEditor.getValue()
      console.log('cache values updated:', this.cachedValues)
    }
  }

  getValue () {
    return this.value
  }

  refreshValue () {
    // console.log('-- refresh value', this.value)
    this.value = {}

    if (!this.typeEditor) {
      return
    }

    this.value[this.typePropertyName] = this.typeEditor.getValue()
    this.value[this.typeEditor.getValue()] = this.childEditor.getValue()
  }
}

export default TypeSelector
